module.exports = __webpack_public_path__ + "static/giveaway2.987d95d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageGiveaway/images/giveaway2.jpg
// module id = 736
// module chunks = 76277878166992